<template>
  <header class="app-header">
    <!-- 顶部公告 -->
    <div class="head-top">
      <div class="w-1200 top-inner">
        <div class="notice">
          <marquee scrollamount="5">
            <p>表面增效功能基本上线，多款合并下单价格不完善，请联系客服</p>
          </marquee>
        </div>
        <div class="auth" v-if="user && user.id">
          欢迎您!{{ user.name }}
          <el-button type="text" @click="logout">退出</el-button>
        </div>
        <div class="auth" v-else>
          <router-link to="/login">登录</router-link>
          <span />
          <router-link to="/register">注册</router-link>
        </div>
      </div>
    </div>

    <!-- LOGO + 联系 -->
    <div class="pc-head" :style="{ backgroundImage: `url(${bgImage})` }">
      <div class="w-1200 pc-head-top">
        <router-link to="/" class="logo">
          <img src="@/assets/logo.png" />
        </router-link>

        <div class="contact" @click="openQQ">工厂QQ：123123123</div>
      </div>

      <!-- Element 导航 -->
      <div class="header-menu">
        <!-- 顶部横向导航 -->
        <div class="top-menu-wrap">
          <div class="top-menu-main w-1200">
            <el-menu
              mode="horizontal"
              background-color="#e5e5e5"
              text-color="#666"
              active-text-color="#409EFF"
              :router="true"
              :default-active="$route.path"
              class="top-menu"
            >
              <!-- 产品分类：不是路由 -->
              <el-menu-item index @click="showCategory = !showCategory" class="category-trigger">
                产品分类
                <i class="el-icon-menu"></i>
              </el-menu-item>

              <!-- 路由菜单 -->
              <el-menu-item index="/">网站首页</el-menu-item>
              <el-menu-item index="/offer">报价下单</el-menu-item>
              <el-menu-item index="/order">订单查询</el-menu-item>

              <el-menu-item index="/matter">注意事项</el-menu-item>
              <el-menu-item index="/guide">操作指引</el-menu-item>
              <el-menu-item index="/contact">联系我们</el-menu-item>
            </el-menu>
            <el-menu class="side-menu" :router="true" v-show="showCategory" :default-active="$route.path">
              <el-menu-item index="/offer">
                <div class="side-item">
                  <div class="title">卷装标签</div>
                  <div class="desc">合适 四色+专色，可变数据，烫金，UV，可平张</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/offer1">
                <div class="side-item">
                  <div class="title">卷装亮银，透明标签</div>
                  <div class="desc">合适 白+4色+专色工艺，可变数据，烫金，UV，可平张</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/offer2">
                <div class="side-item">
                  <div class="title">黑白不干胶</div>
                  <div class="desc">合适简单黑白色印刷，无工艺。可卷可平张</div>
                </div>
              </el-menu-item>

              <el-menu-item index="/ask">
                <div class="side-item">
                  <div class="title">有问有答</div>
                  <div class="desc">费用与工艺说明</div>
                </div>
              </el-menu-item>
            </el-menu>
          </div>
        </div>

        <!-- 主体区域 -->
      </div>
    </div>
  </header>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'AppHeader',
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  data() {
    return {
      showCategory: true,
      bgImage: 'image/f5743ada5117847697d22697da64bbe3.jpg',
      navList: [
        { title: '网站首页', path: '/' },
        { title: '报价下单', path: '/offer' },
        { title: '订单查询', path: '/order_query' },
        { title: '注意事项', path: '/matter' },
        { title: '操作指引', path: '/guide' },
        { title: '联系我们', path: '/contact_us' }
      ],
      productList: [
        {
          title: '卷装标签',
          path: '/offer',
          desc: '四色+专色，可变数据，烫金，UV'
        },
        {
          title: '亮银 / 透明标签',
          path: '/offer2',
          desc: '白+4色+专色工艺'
        },
        {
          title: '黑白不干胶',
          path: '/offer3',
          desc: '简单黑白印刷'
        },
        {
          title: '有问有答',
          path: '/ask',
          desc: '印刷费用与工艺问题'
        }
      ]
    }
  },
  methods: {
    openQQ() {
      window.open('tencent://message/?uin=3036149250', '_self')
    },
    logout() {
      this.$confirm('确定退出登录吗？', '提示')
        .then(() => {
          this.$store.dispatch('user/logout')
          this.$router.push('/')
        })
        .catch(() => {})
    },
    stopMarquee(e) {
      e.target.stop()
    },
    startMarquee(e) {
      e.target.start()
    }
  }
}
</script>
<style lang="scss" scoped>
.app-header {
  background: #fff;
  z-index: 9999;
  position: relative;
}

.w-1200 {
  max-width: 1200px;
  margin: 0 auto;
}

.head-top {
  background: #232830;
  color: #fecb18;
  padding: 8px 0;

  .top-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  i {
    color: red;
    font-style: normal;
    margin: 0 4px;
  }

  .auth {
    display: flex;
    align-items: center;

    a {
      color: #fff;
      font-size: 16px;
    }

    span {
      width: 1px;
      height: 16px;
      background: #fff;
      margin: 0 15px;
    }
  }
}

.pc-head {
  background-size: cover;

  .pc-head-top {
    height: 99px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo img {
    height: 60px;
  }

  .contact {
    cursor: pointer;
    font-weight: bold;
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;
    }
  }
}

.header-menu {
  background: #f5f5f5;
}

/* 顶部菜单 */
.top-menu-wrap {
  background: #e5e5e5;

  .top-menu-main {
    position: relative;
  }
  .top-menu {
    margin: 0 auto;
    border-bottom: 1px solid #ddd;
  }
}

/* 主体 */
.main-wrap {
  background: #fff;
}

.main-1200 {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
}

.category-trigger {
  width: 240px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  position: relative;
}

/* 左侧分类 */
.side-menu {
  width: 240px;
  border-right: 1px solid #e6e6e6;
  position: absolute;
  top: 61px;
  left: 0;

  .el-menu-item {
    height: auto;
    padding: 12px 16px !important;
    line-height: normal;
    background-color: #f5f5f5;
    border-bottom: 2px solid #005bac85;
  }

  .side-item {
    text-align: center; // 整体居中

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      white-space: normal;
      word-break: break-all;
    }

    .desc {
      font-size: 12px;
      color: #409eff;
      margin-top: 6px;
      width: 100%;
      white-space: normal;
      word-break: break-all;
      line-height: 1.5;
    }
  }

  .el-menu-item.is-active {
    background: #f0f7ff;
    border-left: 4px solid #409eff;
  }
}

/* 右侧内容 */
.content {
  flex: 1;
  padding: 20px;
  min-height: 500px;
}
</style>
